<template>
    <!--
    Main Entrance Component
    -----------------------
    -->
    <router-view></router-view>
    <kt-loading 
        @click="setLoading(false)"
        :visible="loading" 
        fullscreen="true" 
        wheelsize="250px"
    ></kt-loading>
</template>

<script lang="ts" setup>
import { ref, onUnmounted } from "vue";
import { RouterView } from 'vue-router';
import KtLoading from "@/components/UI/KtLoading.vue";
import Emitter from "@/services/Emitter";
import { useAppStore } from "@/stores/AppStore";

// Initialize the AppStore to start the keepalive loop
const appStore = useAppStore();

const loading = ref<number>(0);
const unregister:Array<Function> = [];

const setLoading = (val:boolean | -1) =>
{
    if (typeof val === "boolean")
    {
        loading.value += (val) ? 1 : -1;
    }

    else
    {
        loading.value = -1;
    }

    if (loading.value < 0)
    {
        loading.value = 0;   
    }
}

unregister.push(Emitter.on("loading", (val:boolean) => 
{
    setLoading(val);
}));

onUnmounted(() =>{
    unregister.forEach((func:Function) => {
        func();
    });
})

</script>